import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createWidget } from 'actions/editor';
import { fetchPaletteFolders, fetchComponentsForPalette, fetchComponentsForPaletteFolder, } from 'actions/palette';

import _ from 'lodash';
import cx from 'classnames';
import { Tab, Nav } from 'react-bootstrap';
import { IKImage } from 'imagekitio-react';

import { PaletteContext } from '.';
import { getPositionForNewWidget } from 'components/Editor/helper/layoutManager';
import InfiniteScroll from "components/InfiniteScroll";

import { SEEK } from 'constants/widgetTypes';
import { createMixpanelEvent } from 'actions/mixpanel';
import { MIXPANEL_WIDGET_USED } from 'constants/mixpanelEvents';
import { getStoryboardMixpanelEventPayload } from 'services/mixpanelUtil';
import StoryboardContext from 'components/Storyboard/context';

import styles from './palette.module.scss';
import { BrandkitEmptyMessageCard, FolderPaletteComponentsView, MultiwidgetPaletteComponentsView } from './multiWidgetFolderPalette';
import { PaletteComponentCard } from './paletteComponentCard';
import { ShortLoader } from 'components/ApplicationLoader';

export const SeekPalette = ({ editorSession, defaultParent }) => {
  const paletteContext = React.useContext(PaletteContext);

  const { palettes = [] } = paletteContext;

  const paletteData = palettes.find(item => item.type === 'SEEK');
  const defaultId = _.get(paletteData, 'defaultId', null);
  const brandkitId = _.get(paletteData, 'brandkitId', null);

  return (
    <Tab.Pane eventKey="SEEK" className={cx(styles.tabPane, styles.seekPalette)}>
      <SeekWidgetPaletteFolders
        editorSession={editorSession}
        defaultParent={defaultParent}
        defaultPaletteId={defaultId}
        paletteId={brandkitId}
        type={'default'}
        paletteData={paletteData}
        typeName={'SEEK'}
      />
    </Tab.Pane>
  );
}

export const SeekWidgetPaletteFolders = ({ editorSession, defaultParent, defaultPaletteId, paletteId, type, paletteData, typeName }) => {

  const dispatch = useDispatch();
  const iconPaletteRef = React.useRef(null);

  const folders = useSelector(state => _.get(state, `palette.brandkit[${paletteId}].folders.items`, []));
  const defaultFolders = useSelector(state => _.get(state, `palette.default[${defaultPaletteId}].folders.items`, []));

  const fetched = useSelector(state => _.get(state, `palette.brandkit[${paletteId}].folders.fetched`, false));
  const fetchedDefault = useSelector(state => _.get(state, `palette.default[${defaultPaletteId}].folders.fetched`, false));

  const components = useSelector(state => { return _.get(state, `palette.default[${paletteId}].items`) || [] });
  const brandKitComponents = useSelector(state => { return _.get(state, `palette.brandkit[${paletteId}].items`) || [] });

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const brandkitEnabled = _.get(workspace, 'brandkitEnabled', false);
  const showDefault = _.get(paletteData, 'showDefault', false) || !brandkitEnabled;

  const showOtherBrandkitFolder = brandKitComponents.length > 0 || components.length > 0;

  const showEmptyMessage = components.length == 0 && !showDefault && folders.length == 0;

  useEffect(() => {
    if (paletteId && !fetched) {
      dispatch(fetchPaletteFolders(paletteId, 'brandkit'));
      handleComponentsForPalette(0);
    }
  }, [paletteId]);

  useEffect(() => {
    if (defaultPaletteId && !fetchedDefault) {
      dispatch(fetchPaletteFolders(defaultPaletteId, 'default'));
      handleComponentsForPalette(0);
    }
  }, [defaultPaletteId]);

  const handleComponentsForPalette = (page) => {
    var request = {
      sort: 'order',
      order: 'ASC',
      widgetResponse: false
    }
    dispatch(fetchComponentsForPalette(paletteId, type, request, page, 50));
  }

  const handleFolderSelect = (folder) => {
    console.log("pressed")
    const folderElement = document.getElementById(folder);
    if (folderElement) {
      folderElement.scrollIntoView({ behavior: 'smooth' });
    }
  }  

  if(!fetchedDefault || !fetched) return (
    <div className={styles.paletteLoaderContainer}>
      <ShortLoader className={styles.paletteLoaderContainer}/>
    </div>
  );

  return (
    <>
    { showEmptyMessage &&
      <BrandkitEmptyMessageCard/>
    }

    
    { !showEmptyMessage && 
      <div className={styles.iconManagement}>
        <div className={styles.iconFolders}>
          <Nav variant="pills" className={styles.iconManagementTab}>

          {brandkitEnabled && (folders.length>0 || showOtherBrandkitFolder) && 
            <>
              <div className={styles.headerTitle}>{`BRAND ${typeName}`}</div>
              {folders.map(folder => {
                return (
                  <Nav.Item key={folder.id} onClick={() => { handleFolderSelect(folder.id) }}>
                    <Nav.Link eventKey={folder.id}>{folder.name}</Nav.Link>
                  </Nav.Item>
                )
              })}

              {showOtherBrandkitFolder && 
                <Nav.Item key={'seekOtherFolder'} onClick={() => { handleFolderSelect('seekOtherFolder') }}>
                <Nav.Link eventKey={'seekOtherFolder'}>Other</Nav.Link>
              </Nav.Item>
              }
              <hr />
            </>
          }

          {showDefault && 
              <>
                <div className={styles.headerTitle}>CLEVERSTORY</div>
                {defaultFolders.map(folder => {
                  return (
                    <Nav.Item key={folder.id} onClick={() => { handleFolderSelect(folder.id) }}>
                      <Nav.Link eventKey={folder.id}>{folder.name}</Nav.Link>
                    </Nav.Item>
                  )
                })}

                {!_.includes(['ASSET GRIDS'], typeName) && 
                  <Nav.Item key={'seekDefaultFolder'} onClick={() => { handleFolderSelect('seekDefaultFolder') }}>
                    <Nav.Link eventKey={'seekDefaultFolder'}>Default</Nav.Link>
                  </Nav.Item>
                }
            </>
          }
          </Nav>
        </div>

        <div className={styles.iconContent} ref={iconPaletteRef}>
        <div className={styles.seekHeader}>
        <div className={styles.logoContainer}>
          <span className={styles.seekLogo}>seek</span>
          <span className={styles.seekSubText}>Powered by Paperflite</span>
        </div>

        <a className={styles.knowMore} href='https://experiences.cleverstory.io/introducing-seek' target='_blank'>
          <i className={cx(styles.icon, "cleverstory-url")} />
          <span>Know More</span>
        </a>
      </div>
          {brandkitEnabled && (folders.length>0 || showOtherBrandkitFolder) &&
            <>
              <div className={cx(styles.paletteTitle, styles.shapeTitle)}>
                <h3 className={styles.label}>{`BRAND ${typeName}`}</h3>
                <hr className={styles.labelHighliter} />
              </div>

              {folders.map(folder => {
                return (
                  <FolderPaletteComponentsView
                    key={folder.id}
                    editorSession={editorSession}
                    defaultParent={defaultParent}
                    paletteId={paletteId}
                    folder={folder}
                    type={type}
                    typeName={typeName}
                  />
                )
              })}

              {showOtherBrandkitFolder &&
                <MultiwidgetPaletteComponentsView editorSession={editorSession}
                defaultParent={defaultParent}
                paletteId={paletteId}
                type={'brandkit'}  
                typeName={typeName}
                folderName={'Other'}
                folderId={'seekOtherFolder'}
                />
              }

              </>
          }

          {showDefault && 
            <>
              <div className={cx(styles.paletteTitle, styles.shapeTitle)}>
                <h3 className={styles.label}>CLEVERSTORY</h3>
                <hr className={styles.labelHighliter} />
              </div>
            
              {defaultFolders.map(folder => {
                return (
                  <FolderPaletteComponentsView
                    key={folder.id}
                    editorSession={editorSession}
                    defaultParent={defaultParent}
                    paletteId={paletteId}
                    folder={folder}
                    type={type}
                    typeName={typeName}
                  />
                )
              })}

              <SeekPaletteView
              editorSession={editorSession}
              defaultParent={defaultParent}
              paletteId={defaultPaletteId}
              type={'default'}
              folderId={'seekDefaultFolder'}
              typeName={typeName}
              />
            </>
          }

        </div>
      </div>
    }
    </>
  )
}

export const SeekPaletteView = ({ editorSession, defaultParent, paletteId, type, folderId }) => {
  const dispatch = useDispatch();
  const storyboardContext = React.useContext(StoryboardContext);

  const paletteContext = React.useContext(PaletteContext);

  const parentWidget = useSelector(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || []
    return widgets.find(widget => {
      return widget.uid === defaultParent
    });
  });
  const desktopParentLayout = _.get(parentWidget, `properties.desktop.layout`);
  const mobileParentLayout = _.get(parentWidget, `properties.mobile.layout`);

  const components = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].items`) || [] })
  const loading = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].loading`) || false })
  const fetched = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].fetched`) || false })
  const pagination = useSelector(state => { return _.get(state, `palette.[${type}][${paletteId}].pagination`) || {} })
  const hasMoreItems = _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;

  useEffect(() => {
    if (paletteId && !fetched) {
      handleComponentsForPalette(0);
    }
  }, [paletteId]);

  const handleComponentsForPalette = (page) => {
    var request = {
      sort: 'order',
      order: 'ASC'
    }
    dispatch(fetchComponentsForPalette(paletteId, type, request, page, 50));
  }

  const loadMore = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }
    handleComponentsForPalette(nextPage);
  }

  const handleCreateSeekBar = (data) => {
    const formatString = (value) => {
      if (value) {
        value = value.replace(/_/g, " ");
  
        value = value
          .toLowerCase()
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }
      return value;
    };
    const desktopPosition = getPositionForNewWidget(editorSession, desktopParentLayout, { width: 1200, height: 55 });
    const mobilePosition = getPositionForNewWidget(editorSession, mobileParentLayout, { width: 375, height: 55 });

    const type = _.get(data, 'properties.desktop.questionDesign.type', 'bar');
    const defaultPosition = _.get(data, 'properties.desktop.layout.transform', {
      translate: "0px, 20px",
      rotate: "0deg"
    });

    dispatch(
      createWidget(
        editorSession,
        [
          {
            type: SEEK,
            name: "Seek",
            properties: {
              ...data.properties,
              desktop: {
                ...data.properties.desktop,
                visible: true,
                layout: {
                  ...data.properties.desktop.layout,
                  transform: {
                    translate: type == 'button' ? `${defaultPosition.translate}` : `${desktopPosition.x}px, ${desktopPosition.y}px`,
                    rotate: "0deg"
                  }
                }
              },
              mobile: {
                ...data.properties.mobile,
                visible: true,
                layout: {
                  ...data.properties.mobile.layout,
                  transform: {
                    translate: type == 'button' ? `${defaultPosition.translate}` : `0px, ${mobilePosition.y}px`,
                    rotate: "0deg",
                  }
                }
              },
            },
            widgets: data.widgets,
            content: data.content
          },
        ],
        defaultParent
      )
    );
    var mixpanelPayload = getStoryboardMixpanelEventPayload(storyboardContext.id, storyboardContext.name, storyboardContext.type);
    mixpanelPayload = {
      ...mixpanelPayload,
      widget_type: 'Seek',
      brandkit_widget: false,
    }
    dispatch(createMixpanelEvent(MIXPANEL_WIDGET_USED, mixpanelPayload))

    paletteContext.close();
  }

  return (
    <div className={styles.defaultWidgets} id={folderId}>
      <InfiniteScroll
        className={cx(styles.scrollable)}
        loading={loading}
        hasMore={hasMoreItems}
        loadMore={loadMore}
      >
        {components.map((component, index) => {
          const widgets = _.get(component, 'content.widgets', []);
          if (!widgets) {
            return null;
          }

          const widget = widgets[0];
          const icon = _.get(component, 'icon.url', null);

          return (
            <div key={index} className={styles.widget} onClick={() => handleCreateSeekBar(widget)}>
              <IKImage
                className={styles.icon}
                path={icon}
              />
            </div>
          );
        })}
      </InfiniteScroll>
    </div>
  )
}